<div class="box-input escape-confirm">
  <label v-if="label" :for="updatedLabel" class="txt-ellipsis bold">
    {{ updatedLabel && $t(updatedLabel) }}
    <span v-if="required" class="txt-danger txt-required">
      <span>*</span>
    </span>
  </label>
  <div class="row">
    <div v-if="textEditor">
      <text-editor
        v-model="value"
        :readonly="readonly"
        :isError="isError ? true : false"
        :placeholder="placeholder ? placeholder : 'componentWriteSomething'"
        :editorOption="editorOption"
        @update="updateEditor($event)"
      />
    </div>
    <div v-else>
      <textarea
        v-if="readonly"
        :value="value"
        :type="validateType(type === 'number' ? 'text' : type)"
        :placeholder="placeholder ? $t(placeholder) : $t('componentWriteSomething')"
        :class="{ 'outline-danger': isError, pl46: type == 'tel' }"
        :ref="refIds"
        class="input is_readonly"
        v-bind:autocomplete="autocompleteValue"
        readonly
        :rows="rows"
      />
      <textarea
        v-else
        :value="value"
        @keyup.enter="onEnter"
        @keyup="onKeypress($event)"
        @keypress="onKeypress($event)"
        @change="onKeypress($event)"
        @input="onEmits($event)"
        @keydown="handleKeyDown"
        :type="validateType(type === 'number' ? 'text' : type)"
        :placeholder="placeholder ? $t(placeholder) : $t('componentWriteSomething')"
        :class="{ 'outline-danger': isError, pl30: type == 'tel' }"
        :ref="refIds"
        class="input editor"
        v-bind:autocomplete="autocompleteValue"
        :min="minDate || ''"
        :rows="rows"
      />
    </div>
    <!-- <button
      v-if="readonly && value"
      @click="copyToClipboard"
      :tooltip="showPopup ? $t('componentCopied') : $t('componentCopy')"
      class="btn btn-danger btn-xs clone-icon tooltip mr14"
      style="right: 9px; top: 13px"
    >
      <i class="fa fa-clone"></i>
    </button> -->
    <span v-if="type == 'tel'" class="tel-prefix">0</span>
  </div>
  <p v-if="isError" class="mb0 txt-danger font14 mt3">
    <span>{{ $t(isError) }}</span>
  </p>
</div>
